<template>
  <div class="fiber">
    <div id="wrapper-background">
        <img src="../assets/maps2.png">
        <div class="wrapper">
          <div class="img-wrapper">
            <img src="../assets/logo.png">
            <img src="../assets/label.png">
          </div>
        </div>
         <v-selected label="address" :options="options" :placeholder="'Search your area'" :filterable="false" @search="onSearch" @scrollAjax="ScrollUp" @clearCache= "options = []">
            <template slot="no-options">
              <span v-if="hasEntry">No result.</span>
              <span v-else>type to search your area.</span>
            </template>
            <template slot="option" slot-scope="option">
                <a @click="objSelected = option" data-toggle="modal" data-target="#exampleModalCenter">
                  <img src="../assets/place.png" style="width: 9px; margin-right: 5px;" alt=""><span class="grey" v-html="option.address"></span>
                </a> 
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option | rmHtml}}
            </template>
        </v-selected>
    </div>
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="width: 70%;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Select Action</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div style="padding: 1rem;">
            <button type="button" v-clipboard="copyTxt" class="btn btn-secondary" style="margin:5px;">
              <img src="../assets/copy.png" alt="" style="margin-right: 3px; width: 15px; margin-bottom: 3px;">Copy address
            </button>
            <button type="button" @click="toUrl" class="btn" style="background: #007db8; border: #007db8; color: #fff; margin:5px;">
              <img src="../assets/maps-icon.png" alt="" style="margin-right: 3px; width: 15px; margin-bottom: 3px;">Go to maps
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'filterMenu',
  data () {
    return {
      msg: 'Filter Fiber',
      typeChar: '',
      options: [],
      hasEntry: false,
      selected: '',
      searchParam: [],
      page: 1,
      signKey: [],
      saveEntryWord: '',
      plBlack: '../assets/place.png',
      objSelected: ''
    }
  },
  created() {
    if (this.$route.path === 'http://mdn.nusa.net.id') {
       window.location.href = 'https://mdn.nusa.net.id/'
    }
    
  },
  filters: {
    rmHtml: function (value) {
      return value.address.replace(/<(.|\n)*?>/g, '');
    }
  },
  methods:{
    ScrollUp(hiddenPos, position, percentPos) {
        if (percentPos > ( 100 - (20 / this.page) )) {
          if(this.searchParam.length) {
            if(this.options.length != length){
              this.getApi(this.searchParam[0], this.searchParam[1], this.searchParam[2], this.page + 1)
            }
            length = this.options.length
          }
      }
    },
    onSearch(search, loading) {
      // loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      vm.searchParam = [loading, search, vm];
      if (search.length > 2) {
        vm.page = 1;
        vm.getApi(loading, search, vm, vm.page)
      } else {
        loading(false);
        vm.options = []
      }
    }, 350),
    toUrl() {
      let selected = this.objSelected
      var link = selected.true_coordinate == null ? selected.coordinate : selected.true_coordinate;
      window.open('https://maps.google.com?q='+link, '_blank');
    },
    copyTxt() {
      return this.objSelected.address ? this.objSelected.address.replace(/<(.|\n)*?>/g, '') : '';
    },
    getApi(loading, search, vm, page) {
      let entryWords = search.trim().split(/\s+/)
      //www.nusa.net.id
      axios.get(`/v2/customer/fiberstar/api?q=${escape(search)}&page=${page}`, {withCredentials: true})
          .then(res => {
            for (var row of res.data.data) {
              for (var keyword of entryWords) {
                row.address = row.address.replace(new RegExp(keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i'), '<strong>$&</strong>');
              }
            }
            // loading(false);
            if(this.saveEntryWord != search) vm.options = []
              vm.options  = vm.options.concat(res.data.data)
              vm.hasEntry = vm.options.length == 0 ? true : false;
              this.page   = page
              this.saveEntryWord = search
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#wrapper-background {
  position: relative;
}
#wrapper-background img {
  max-width: 100%;
  height: auto;
}

.wrapper {
  position: absolute;
  width: 100%;
  bottom: 57px;
}
.wrapper img{
  max-width: 100%;
  height: auto;
}

.img-wrapper {
  position: relative;
  width: 25%;
  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/FilterFiber.vue